module.exports = __webpack_public_path__ + "img/pesa-ap3.4c394cc7.png";